import { render, staticRenderFns } from "./segment-name-input.vue?vue&type=template&id=68845840"
import script from "./segment-name-input.vue?vue&type=script&lang=js"
export * from "./segment-name-input.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports